import { Common } from './common';
import { Nullable } from './models/common';
import {
  BaseSetting,
  Setting,
  FlagMap,
  FlagOptions,
} from './models/featureFlag';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async create(toAdd: BaseSetting): Promise<Setting> {
    const url = this.common.constructPath('/featureFlags/settings');
    const { setting } = await this.common.postJSON(url, toAdd);
    return setting;
  }

  async update(id: string, option: string): Promise<Setting> {
    const url = this.common.constructPath(`/featureFlags/settings/${id}`);
    const { setting } = await this.common.putJSON(url, { option });
    return setting;
  }

  async delete(id: string): Promise<boolean> {
    const url = this.common.constructPath(`/featureFlags/settings/${id}`);
    const { success } = await this.common.deleteJSON(url);
    return success;
  }

  async me(): Promise<Setting[]> {
    const url = this.common.constructPath(`/featureFlags/me`);
    const { settings } = await this.common.getJSON(url);
    return settings;
  }

  async get(
    userId: string,
    includeFlagDescriptions: true,
  ): Promise<{ flags: FlagMap; flagDescriptions: FlagOptions }>;
  async get(userId: string): Promise<{ flags: FlagMap }>;
  async get(userId: string, includeFlagDescriptions?: true) {
    let url = this.common.constructPath(`/users/${userId}/featureFlags`);
    if (includeFlagDescriptions) {
      url = `${url}?includeFlagDescriptions=true`;
    }
    return this.common.getJSON(url);
  }

  async set(
    userId: string,
    values: Partial<Nullable<FlagMap>>,
  ): Promise<{ flags: FlagMap }> {
    const url = this.common.constructPath(`/users/${userId}/featureFlags`);
    return this.common.patchJSON(url, { flags: values });
  }
}
